/** Money and amount formatting. One definition each, so two panels cannot disagree. */
export const SUN_PER_TRX = 1_000_000;
/**
 * The locale grouped integers are written in. A Russian reader takes `65,000` for sixty-five
 * with decimals, so a Russian page groups with a space (`65 000`), as its static copy does.
 * TRX amounts keep the decimal point in every locale (`formatTrx`): that is how the site, the
 * wallets and the explorers all write a coin amount. The page sets this once per document
 * (`setNumberLocale(document.documentElement.lang)`, or the cabinet with the locale's BCP-47 tag
 * from `LOCALE_CONFIG`); English is the default. Any tag `Intl` accepts works — `ru`, `ru-RU`,
 * `de` — so a new site locale needs no entry here.
 */
let amountLocale = "en-US";
export function setNumberLocale(locale) {
    amountLocale = locale && locale.trim() !== "" ? locale : "en-US";
}
/** SUN as TRX, fixed to `fractionDigits` so a total never renders as `1.3` and `1.300`. */
export function formatTrx(sun, fractionDigits = 3) {
    const text = (sun / SUN_PER_TRX).toLocaleString("en-US", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
    // The decimal point stays; only the thousands separator follows the page (`4 944 TRX` on a
    // Russian page, where `4,944` reads as a fraction).
    return amountLocale.startsWith("en") ? text : text.replace(/,/g, "\u00a0");
}
/** A plain grouped integer: `65,000` (`65 000` on a Russian page). */
export function formatAmount(value) {
    return value.toLocaleString(amountLocale);
}
/** `1.2M`, `340k`, `65,000` — the widths a one-line summary can carry. */
export function compactAmount(amount) {
    if (!Number.isFinite(amount) || amount <= 0)
        return "0";
    if (amount >= 1_000_000) {
        const millions = amount / 1_000_000;
        return `${millions >= 10 ? Math.round(millions) : Math.round(millions * 10) / 10}M`;
    }
    if (amount >= 10_000)
        return `${Math.round(amount / 1_000)}k`;
    return amount.toLocaleString(amountLocale);
}
/** A price as the book publishes it: whole SUN where it is whole, two decimals where not. */
export function formatLevelPrice(priceSun) {
    return Number.isInteger(priceSun) ? String(priceSun) : priceSun.toFixed(2);
}
//# sourceMappingURL=numbers.js.map